import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {readNotification, deleteNotification} from '../../../SHARED/actions/profile.actions';
import { slugify } from '../../helpers/general.helper';

class CinemapAccordionItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
            seen: this.props.seen
        };
    }

    handleItemClick = () => {
        this.setState(prevState => ({
            expanded: !prevState.expanded,
            seen: !prevState.seen ? true : true
        }));
        if (!this.props.seen){
            this.props.readNotification(this.props.id);
        }
    };

    deleteNotification = () => {
        this.props.deleteNotification(`${this.props.type}/${this.props.uuid}`);
    }
    
    notificationDetails = () => {
            switch(this.props.type){
                case "notif_film":
                    return <Link to={`/film/${this.props.articleId}/${slugify(this.props.title)}`}> Vezi filmul</Link>
                case 'notif_event':
                    return <Link to={`/eveniment/${this.props.articleId}/${slugify(this.props.title)}`}> Vezi evenimentul</Link>
                case 'notif_article':
                    return <Link to={`/stiri/${this.props.articleId}/${slugify(this.props.title)}`}> Vezi știrea</Link>
                default:
                    break;
            }
    }

    render() {
        return (
            <Fragment>
                <div className={!this.state.expanded ? "accordion-item" : 'accordion-item expanded'}>
                    <span onClick={this.deleteNotification} className="notification-delete" />
                    <div className="accordion-title clearfix" >
                        <div className={this.state.seen ? "accordion-envelope float-left seen" : "accordion-envelope float-left unseen"}>
                            <span className="icon-email-small" />
                        </div>
                        <div className="accordion-main-content float-left">
                            <span className={this.state.seen ? 'notif-title seen' : 'notif-title unseen'}>{ this.props.title }</span>
                            <span className="notif-preview">
                                { !this.state.expanded ? this.props.preview : '' }
                                { !this.state.expanded ? <span className="read-more" onClick={()=> this.handleItemClick()} >Citeşte tot...</span> : ''}
                            </span>
                        </div>
                    </div>
                    <div className="accordion-body">
                        <p className="notif-body">
                            { this.state.expanded ? this.props.body : '' }
                            { this.state.expanded ? this.notificationDetails() : '' }
                        </p>
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {readNotification, deleteNotification})(CinemapAccordionItem);






// WEBPACK FOOTER //
// ./src/SHARED/components/accordionitem/accordionitem.component.js